var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle7, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnailEmptyPicture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 306,
    viewBox: "0 0 306 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.737,
    cy: 154.913,
    r: 95.8982,
    fill: "#F1F3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.8496,
    cy: 90.1607,
    r: 6.01071,
    fill: "#F1F3FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.308,
    cy: 66.3911,
    r: 11.2018,
    fill: "#F1F3FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.7618,
    cy: 216.659,
    r: 10.6554,
    fill: "#F1F3FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.466,
    cy: 206.277,
    r: 10.6554,
    fill: "#F1F3FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.702,
    cy: 218.298,
    r: 5.19107,
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.051 63.1328C173.734 63.0654 173.734 62.6133 174.051 62.5459L178.841 61.5274C178.956 61.5028 179.046 61.4129 179.071 61.2975L180.103 56.5414C180.171 56.2262 180.621 56.2262 180.689 56.5414L181.72 61.2975C181.745 61.4129 181.836 61.5028 181.951 61.5274L186.741 62.5459C187.058 62.6133 187.058 63.0655 186.741 63.1328L181.951 64.1514C181.836 64.1759 181.745 64.2659 181.72 64.3812L180.689 69.1373C180.621 69.4525 180.171 69.4525 180.103 69.1373L179.071 64.3812C179.046 64.2659 178.956 64.1759 178.841 64.1514L174.051 63.1328Z",
    fill: "#C4CBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8357 169.186C43.958 168.609 44.7826 168.609 44.9049 169.186L46.7315 177.816C46.776 178.026 46.9397 178.191 47.1497 178.237L55.6901 180.097C56.2636 180.222 56.2636 181.04 55.6901 181.165L47.1497 183.025C46.9397 183.071 46.776 183.236 46.7315 183.446L44.9049 192.076C44.7826 192.653 43.958 192.653 43.8357 192.076L42.0091 183.446C41.9646 183.236 41.8009 183.071 41.5908 183.025L33.0504 181.165C32.4769 181.04 32.4769 180.222 33.0504 180.097L41.5908 178.237C41.8009 178.191 41.9646 178.026 42.0091 177.816L43.8357 169.186Z",
    fill: "#C4CBF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.442 92.6863C244.564 92.1086 245.389 92.1086 245.511 92.6863L246.577 97.7206C246.621 97.9309 246.785 98.0956 246.995 98.1413L251.992 99.2298C252.565 99.3548 252.565 100.173 251.992 100.298L246.995 101.386C246.785 101.432 246.621 101.597 246.577 101.807L245.511 106.841C245.389 107.419 244.564 107.419 244.442 106.841L243.376 101.807C243.332 101.597 243.168 101.432 242.958 101.386L237.962 100.298C237.388 100.173 237.388 99.3548 237.962 99.2298L242.958 98.1413C243.168 98.0956 243.332 97.9309 243.376 97.7206L244.442 92.6863Z",
    fill: "#C4CBF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.47 173.399L268.143 181.304L275.935 183.002L268.143 184.699L266.47 192.605L264.796 184.699L257.004 183.002L264.796 181.304L266.47 173.399Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 156.816,
    y: 100.044,
    width: 98.2853,
    height: 105.826,
    rx: 5.64026,
    transform: "rotate(10 156.816 100.044)",
    fill: "white",
    stroke: "#C4CBF5",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 161.521,
    y: 106.764,
    width: 86.1046,
    height: 75.084,
    rx: 5.64026,
    transform: "rotate(10 161.521 106.764)",
    fill: "#F1F3FF",
    stroke: "#F1F3FF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.6804,
    y: 117.112,
    width: 98.2853,
    height: 105.826,
    rx: 5.64026,
    transform: "rotate(-10 61.6804 117.112)",
    fill: "white",
    stroke: "#C4CBF5",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.4001,
    y: 121.817,
    width: 86.1046,
    height: 75.084,
    rx: 5.64026,
    transform: "rotate(-10 68.4001 121.817)",
    fill: "#F1F3FF",
    stroke: "#F1F3FF",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 102.062,
    y: 91.3459,
    width: 117.26,
    height: 126.287,
    rx: 6.55472,
    fill: "white",
    stroke: "#C4CBF5",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 109.006,
    y: 98.2894,
    width: 102.679,
    height: 89.4868,
    rx: 6.55472,
    fill: "url(#paint0_linear_116_3808)",
    stroke: "#C4CBF5",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.549,
    cy: 119.655,
    r: 8.11875,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.838 136.229C184.374 135.386 185.605 135.386 186.14 136.229L203.793 164.025C204.37 164.933 203.718 166.12 202.642 166.12H167.336C166.261 166.12 165.609 164.933 166.185 164.025L183.838 136.229Z",
    fill: "#C4CBF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.853 118.4C143.99 118.167 144.326 118.162 144.47 118.391L173.63 164.764C173.781 165.004 173.609 165.317 173.325 165.317H116.883C116.604 165.317 116.431 165.013 116.572 164.773L143.853 118.4L143.018 117.909L143.853 118.4Z",
    fill: "#DDE2FF",
    stroke: "#DDE2FF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.599 116.066C143.816 115.688 144.359 115.68 144.587 116.051L152.401 128.787C152.726 129.318 152.092 129.915 151.582 129.558L149.213 127.9C149.01 127.757 148.738 127.762 148.539 127.911L145.163 130.443C144.996 130.568 144.775 130.593 144.585 130.509L140.652 128.761C140.502 128.694 140.331 128.695 140.182 128.763L136.569 130.405C136.061 130.636 135.555 130.08 135.833 129.596L143.599 116.066Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.58 134.301C185.419 134.02 185.017 134.014 184.847 134.29L179.05 143.739C178.808 144.133 179.279 144.576 179.658 144.311L181.394 143.095C181.555 142.983 181.772 142.995 181.919 143.124L184.395 145.29C184.53 145.408 184.725 145.429 184.882 145.342L187.754 143.746C187.872 143.681 188.014 143.675 188.137 143.731L190.796 144.94C191.173 145.111 191.548 144.699 191.342 144.34L185.58 134.301Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.575 171.32H152.515",
    stroke: "#DDE2FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M110.925 166.115H210.921",
    stroke: "#C4CBF5",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M145.132 175.564H162.48",
    stroke: "#DDE2FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.218 175.748H142.551",
    stroke: "#DDE2FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.454 171.689H187.942",
    stroke: "#DDE2FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_3808",
    x1: 184.146,
    y1: 113.11,
    x2: 109.831,
    y2: 192.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailEmptyPicture);
export default __webpack_public_path__ + "static/media/thumbnail_empty_picture.accf71475ed86ca8239de1ff3fab733d.svg";
export { ForwardRef as ReactComponent };